import { observer } from 'mobx-react';
import React, { createContext, PropsWithChildren, ReactElement, useContext } from 'react';

import { StateStore } from '../stores/StateStore';
import { ComponentConfigsMap, Properties } from './ComponentsMap';
import ObjectForm, { FormProperties } from './ObjectForm';


interface Props<T extends Properties, O> {
    store: StateStore<T>,
    components: ComponentConfigsMap<T, O>,
    properties?: FormProperties<T>,
    optional?: O
}

/**
 * Object form to be used with StateStores
 */
const StateStoreForm = <T extends Properties, O = undefined>({
    store,
    ...rest
}: PropsWithChildren<Props<T, O>>): ReactElement | null => {

    const {
        getState,
        setState
    } = useContext(createContext(store));

    return (
        <ObjectForm
            values={getState}
            setValues={setState}
            {...rest}
        />
    )
}

export default observer(StateStoreForm);
